import { SystemStatus } from "constants/systems"

// @todo -- revisit if these are still needed -- likely an artifact from amplify days!
export type ClientConfigurationDetail = {
    applicationId: string
    environmentName: string
}

type SystemsSliceState = {
    hotspotDetectionEngine: SystemStatus
    infraredImageUploads: SystemStatus
    firePerimeterUploads: SystemStatus
    clientConfiguration?: ClientConfigurationDetail
    isInitializingClientApplication: boolean
}

export const initialState = {
    hotspotDetectionEngine: SystemStatus.Enabled,
    infraredImageUploads: SystemStatus.Enabled,
    firePerimeterUploads: SystemStatus.Enabled,
    clientConfiguration: undefined,
    isInitializingClientApplication: false,
} as SystemsSliceState
